import React, { useEffect, useState } from 'react';
import {
	Case,
	useMonitoringCentreCasesQuery,
} from '../../../../graphql/graphql';
import MonitoringCenterAllRequestsFilter from './MonitoringCenterAllRequestsFilter';
import MonitoringCenterList from '../MonitoringCenterList/MonitoringCenterList';
import useSocket from '../../../Base/Hooks/useSocket';
import { Socket } from '../../../Base/Enums/Socket.enum';
import MonitoringCenterSettingsPanel from '../MonitoringCenterSettings/MonitoringCenterSettingsPanel';
import styles from './MonitoringCenterAllRequests.module.scss';
import { CustomSettingKey } from '../../../Base/Enums/CustomSettingKey.enum';
import { CustomSettingsContextProvider } from '../../../CustomSettings/Services/CustomSettingsContext';
import { MonitoringCenterDefaultColumns } from '../../Consts/MonitoringCenterDefaultColumns.const';
import { useFlatDataList } from '../../../Base/Hooks/useFlatDataList';

const MonitoringCenterAllRequests: React.FC = () => {
	const [filter, setFilter] = useState<object>({});
	const { flatData, pagination, getNextPage, appendData } =
		useFlatDataList<Case>(filter);

	const { data, isLoading, refetch } = useMonitoringCentreCasesQuery({
		...filter,
		pagination,
	});

	useEffect(() => {
		appendData((data?.monitoringCentreCases?.data as Case[]) ?? []);
	}, [data]);

	useEffect(() => {
		refetch();
	}, [filter]);

	useSocket(Socket.CASE_TAKEN, refetch);

	return (
		<CustomSettingsContextProvider
			customSettingsKey={CustomSettingKey.MONITORING_CENTER_ALL_REQUESTS}>
			<div className={styles.wrapper}>
				<MonitoringCenterSettingsPanel
					customSettingKey={CustomSettingKey.MONITORING_CENTER_ALL_REQUESTS}
				/>
				<MonitoringCenterAllRequestsFilter onFilter={setFilter} />
				<MonitoringCenterList
					data={flatData}
					onLoadMore={getNextPage}
					onRefresh={refetch}
					isLoading={isLoading}
					hasMoreData={data?.monitoringCentreCases?.meta?.hasNextPage || false}
					columns={MonitoringCenterDefaultColumns}
				/>
			</div>
		</CustomSettingsContextProvider>
	);
};

export default MonitoringCenterAllRequests;
